import { Link, Navigate, useLocation } from 'react-router-dom';
import { BiError } from 'react-icons/bi';
import classes from './Page404.module.css';

const Page404: React.FC = () => {
  const location = useLocation().pathname;

  if (localStorage.getItem('token')) {
    return <Navigate to='/' />;
  }

  return (
    <div className={classes.notFoundBox}>
      <div className={classes.notFoundHeader}>
        <BiError className={classes.notFoundIcon} />
        <h1>
          Sorry, we couldn't find{' '}
          <span className={classes.notFoundUrl}>{location}</span> page
        </h1>
      </div>
      <Link to='/' className={classes.notFoundBtn}>
        Home Page
      </Link>
    </div>
  );
};

export default Page404;
